export default "__VITE_ASSET__00332164__"